import { AlertTriangle, Clock } from "lucide-react";
import { useEffect, useState } from "react";

/** Cronometro do pedido na coluna. Verde ate 15 min, amarelo ate 20, vermelho
 *  com selo ATRASO depois. `grande` e' o tamanho de cozinha/celular — precisa
 *  ler de longe. */
export default function Timer({ since, grande = false, escuro = false, atrasoMin = 28 }) {
  const [elapsed, setElapsed] = useState(0);
  useEffect(() => {
    if (!since) return undefined;
    const start = new Date(since).getTime();
    const tick = () => setElapsed(Math.floor((Date.now() - start) / 1000));
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [since]);
  if (!since) return null;

  const min = Math.floor(elapsed / 60);
  const seg = elapsed % 60;
  const isLate = min >= atrasoMin;
  // O fundo do card ja e' o semaforo; o timer so precisa ser legivel em cima dele.
  const cor = escuro ? "text-white" : "text-zinc-900";
  const peso = isLate ? "font-bold" : "font-semibold";

  return (
    <div className={`flex items-center gap-1.5 tabular-nums font-mono ${grande ? "text-lg" : "text-base"} ${cor} ${peso}`}>
      {isLate && <AlertTriangle className="w-4 h-4" />}
      <Clock className={grande ? "w-4 h-4" : "w-3.5 h-3.5"} />
      {`${min}:${seg.toString().padStart(2, "0")}`}
      {isLate && <span className={`text-[10px] uppercase tracking-wider font-bold ml-1 px-1.5 py-0.5 rounded ${escuro ? "bg-white text-red-700" : "bg-red-600 text-white"}`}>Atraso</span>}
    </div>
  );
}
